<template>
    <div class="gap-1 hidden md:flex items-center group relative" @click="askLocation">
        <div v-if="location" class="text-xs absolute transition text-emerald-400 text-right right-[100%] mr-1 text-nowrap whitespace-nowrap"
        :style="$attrs.accent_color ? {'color': $attrs.accent_color} : ''">
            {{ $t('Location active') }}
        </div>
        <div v-if="location" class="relative mx-2 mr-4 flex items-center justify-center">
            <span class="absolute inline-flex h-2 w-2 rounded-full bg-emerald-400 opacity-75" :style="$attrs.accent_color ? {'background-color': $attrs.accent_color} : ''"></span>
            <span class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-emerald-400 opacity-75"  :style="$attrs.accent_color ? {'background-color': $attrs.accent_color} : ''"></span>
        </div>
        <div v-else
            class="fixed bottom-20 right-4 sm:right-auto sm:bottom-0 sm:static bg-white sm:bg-gray-200 border border-gray-200 dark:border-neutral-700 sm:border-0 shadow-xl sm:shadow-none cursor-pointer dark:bg-neutral-700 dark:sm:bg-neutral-800 text-sm text-gray-500 dark:text-neutral-400 leading-none border-2 sm:border-gray-200 dark:sm:border-neutral-800 rounded-full inline-flex h-fit">
            <div
                class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none hover:text-primary rounded-full p-6 sm:p-3 text-sm h-fit dark:text-white">
                <svg-vue class="h-4 w-4" icon="marker"></svg-vue>
            </div>
        </div>
    </div>
</template>
  
<script>
import VueCookies from 'vue-cookies'

export default {
    data() {
        return {
            location: null,
            update: 0,
        }
    },
    methods: {
        askLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
                this.update++;
            } else {
                console.log("Geolocation is not supported by this browser.");
            }
        },
        showPosition(position) {
            var Latitude = position.coords.latitude;
            var Longitude = position.coords.longitude;

            VueCookies.set('ClientLocationApproved', true, '30d')
            VueCookies.set('ClientLat', Latitude, '1d')
            VueCookies.set('ClientLong', Longitude, '1d')
            this.location = [Latitude, Longitude];
        }
    },
    created() {
        if (VueCookies.get('ClientLocationApproved')) {
            if (VueCookies.get('ClientLat') && VueCookies.get('ClientLong')) {
                this.location = [VueCookies.get('ClientLat'), VueCookies.get('ClientLong')];
            } else {
                this.askLocation();
            }
        }
    }
};
</script>
  